export default __webpack_public_path__ + "assets/0eba965ba8a3fa53c9e48a8365c1354b.jpg";